import { useState, useEffect } from 'react'

export const useTheme = () => {
    const [isDarkMode, setIsDarkMode] = useState(() => {
        if (typeof window !== 'undefined') {
            const savedTheme = localStorage.getItem('theme')
            if (savedTheme) {
                return savedTheme === 'dark'
            }
            // Default to dark theme
            return true
        }
        return true
    })

    useEffect(() => {
        const root = window.document.documentElement
        if (isDarkMode) {
            root.classList.add('dark')
            localStorage.setItem('theme', 'dark')
        } else {
            root.classList.remove('dark')
            localStorage.setItem('theme', 'light')
        }
    }, [isDarkMode])

    const toggleTheme = () => {
        setIsDarkMode(prev => !prev)
    }

    return {
        isDarkMode,
        toggleTheme
    }
}